'use strict';

(function () {

    angular.module('zp.home').controller('homeController', homeController);

    /**@ngInject */
    function homeController($q, $state, $timeout, $window, mixesService, LoaderService, vendorsService, SearchService, homeContent, SlugerService, PostsService) {

        var vm = this;
        var _sliderVendors = homeContent.sections;
        var _cities = [];
        var width = $window.innerWidth > 1200 ? "360px" : $window.innerWidth > 700 ? "320px" : "260px";

        vm.latestFeed = null;
        vm.latestFeedResponsiveConfig = homeContent.sliderConfig;
        vm.venues = [];
        vm.mixes = null;

        vm.openSliderItem = openSliderItem;
        vm.openCategory = openCategory;
        vm.sections = [];
        vm.sectionsLoaded = false;

        /** Activate function */
        (function () {
            LoaderService.start();
            loadCities().then(loadSliders).then(function () {
                $timeout(LoaderService.stop, 1500);
            });
        })();

        //////////////////////////////////

        function loadSliders() {
            var promises = [];
            var city = _cities.find(function (c) {
                return c.address === 'beograd';
            });
            for (var i = 0; i < _sliderVendors.length; i++) {
                if (_sliderVendors[i].name === 'mix') {
                    promises.push(loadMixes(_sliderVendors[i]));
                } else if (_sliderVendors[i].name === 'inspirations') {
                    promises.push(loadInspiratrons(_sliderVendors[i]));
                } else {
                    promises.push(getOneSliderVendors(_sliderVendors[i], city));
                }
            }
            return $q.all(promises).then(function (results) {
                vm.sections = results;
                vm.sectionsLoaded = true;
                return true;
            });
        }

        function getOneSliderVendors(slider, city) {
            var sliderData = slider;
            sliderData.vendors = [];
            city = city ? city : {};
            return vendorsService.getVendors(slider.name, city.latitude, city.longitude, 50).then(function (result) {
                sliderData.vendors = result.splice(0, sliderData.limit).map(function (r, index) {
                    r.style = getGridItemStyle(index);
                    return r;
                });
                return sliderData;
            });
        }

        function loadMixes(slider) {
            var sliderData = slider;
            sliderData.vendors = [];
            return mixesService.getAll().then(function (response) {
                sliderData.vendors = response.splice(0, sliderData.limit).map(function (mix, index) {
                    return {
                        id: mix.alias,
                        name: mix.name,
                        address: mix.desc,
                        image: mix.img,
                        style: getGridItemStyle(index)
                    };
                });
                return sliderData;
            });
        }

        function loadInspiratrons(slider) {
            var sliderData = slider;
            sliderData.vendors = [];
            return PostsService.getAll().then(function (response) {
                sliderData.vendors = response.splice(0, sliderData.limit).map(function (insp, index) {
                    return {
                        id: insp.title,
                        name: insp.title,
                        address: insp.title,
                        image: insp.image,
                        style: getGridItemStyle(index)
                    };
                });
                return sliderData;
            });
        }

        function loadCities() {
            return SearchService.getCities().then(function (c) {
                var allCities = c.find(function (cit) {
                    return cit.address === 'svi';
                });
                var index = -1;
                if (allCities) {
                    index = c.indexOf(allCities);
                }
                for (var i = 0; i < c.length; i++) {
                    if (i != index) {
                        _cities.push(c[i]);
                    }
                }
                if (allCities) {
                    _cities.push(allCities);
                }
                console.log(_cities);
            });
        }

        function openCategory(category) {
            if (category === 'mix') {
                $state.go('nav.mixes');
            } else {
                $state.go('nav.results', { vendor: category });
            }
        }

        function openSliderItem(category, vendor) {
            if (category === 'mix') {
                $state.go('nav.mix-item', { alias: vendor.id });
            } else {
                $state.go('nav.vendor-slug', { vendor: category, slugCity: SlugerService.generateSlug(vendor.city), slugName: SlugerService.generateSlug(vendor.name) });
            }
        }

        function getGridItemStyle(index) {
            if (index == 2 || index == 3 || index == 5) {
                return {
                    width: width,
                    height: "480px",
                    display: "block"
                };
            }
            return {
                width: width,
                height: "230px",
                display: "block"
            };
        }
    }
})(window.angular);